export const MIN_INBOUND_LABEL_COUNT = 1;
// the maximum allowable number of inbound pallet labels printable in a single batch
export const MAX_INBOUND_LABEL_COUNT = 30;
